module.exports = __webpack_public_path__ + "img/draft.ba645966.svg";